import { BRAND_NAME, canonicalUrl, SITE_URL } from '@/lib/seo/site';
import type { Catalog } from './rules';

export const tiffinSeoTitle = 'Tiffin Service in Mumbai | Poonam Kapur Healthy Kitchen';
export const tiffinSeoDescription = 'Vegetarian tiffin delivery in Mumbai from Poonam Kapur Healthy Kitchen. Explore lunch and dinner options, daily meal subscription plans and available delivery areas.';

export function tiffinServiceAreas(catalog: Pick<Catalog, 'settings' | 'areas'>) {
  const settings = catalog.settings;
  if (!settings || settings.is_demo) return [];
  return catalog.areas.filter((area) => !settings.delivery_area_ids.length || settings.delivery_area_ids.includes(area.id));
}

export function tiffinStructuredData(catalog: Catalog) {
  if (!catalog.settings || catalog.settings.is_demo) return null;
  const url = canonicalUrl('/tiffin');
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    '@id': `${url}#service`,
    name: `${BRAND_NAME} — Vegetarian Tiffin Subscription`,
    serviceType: 'Vegetarian lunch and dinner tiffin subscription',
    url,
    provider: { '@id': `${SITE_URL}/#organization` },
    areaServed: tiffinServiceAreas(catalog).map((area) => ({ '@type': 'Place', name: area.neighbourhood })),
  };
}